import React from "react";
import EventSectionView from "src/pages/section/EventSection/view";

export interface EventSectionVideoProps {
    defaultVideoSrc?: string;
    tabletVideoSrc?: string;
}

export interface EventSectionProps {
}

function EventSection(props: EventSectionProps & EventSectionVideoProps) {

    const defaultVideoSrc = "/videos/video_cards.mp4";
    const tabletVideoSrc = "/videos/video_cards_mob.mp4";

    return <EventSectionView
        {...props}
        defaultVideoSrc={defaultVideoSrc}
        tabletVideoSrc={tabletVideoSrc}/>
}

export default EventSection;